import { render } from "./QueryTypeMaster.vue?vue&type=template&id=c0f710dc&scoped=true"
import script from "./QueryTypeMaster.vue?vue&type=script&lang=js"
export * from "./QueryTypeMaster.vue?vue&type=script&lang=js"

import "./QueryTypeMaster.vue?vue&type=style&index=0&id=c0f710dc&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f710dc"]])

export default __exports__